import type {LandingFaqItem} from '@modules/landing/faqItems';

type JsonLdObject = Record<string, unknown>;

export const serializeJsonLd = (data: JsonLdObject): string =>
	JSON.stringify(data).replace(/</g, '\\u003c');

export const buildWebApplicationJsonLd = ({
	name,
	url,
	description,
}: {
	name: string;
	url: string;
	description: string;
}): JsonLdObject => ({
	'@context': 'https://schema.org',
	'@type': 'WebApplication',
	name,
	url,
	description,
	applicationCategory: 'MusicApplication',
	operatingSystem: 'Web browser',
});

export const buildFaqPageJsonLd = (items: LandingFaqItem[]): JsonLdObject => ({
	'@context': 'https://schema.org',
	'@type': 'FAQPage',
	mainEntity: items.map((item) => ({
		'@type': 'Question',
		name: item.question,
		acceptedAnswer: {
			'@type': 'Answer',
			text: item.answer,
		},
	})),
});
